// import external dependencies
import 'jquery';
import 'swiper/dist/js/swiper.min';
// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archive from './routes/archive';
import singleProduct from './routes/singleproduct';
import templateContact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // archive-product file
  archive,
  // single product page
  singleProduct,
  // contact template page
  templateContact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js